<header>
  <span [routerLink]="['../']" [queryParams]="{ taxYear: question?.year }">
    {{ "settings.back-to-all-questions" | transloco }}</span
  >
  <div>
    <h2 *transloco="let t">
      @if (!isProductionMode) {
      <span>{{
        question?.id ? t("settings.edit") : t("settings.create")
      }}</span>
      }
      {{ "settings.question" | transloco }}
      <span id="question-yr">({{ yearLabel }} {{ question?.year }})</span>
    </h2>

    <div class="actions">
      @if (question?.id) {
      <div
        (click)="syncCache()"
        class="ui primary button"
        [ngClass]="{ loading: isSyncingCache }"
      >
        {{ "settings.sync-cache" | transloco }}
      </div>
      }

      <!-- TRANSLOCO TODO -->
      @if (showDelete && question?.id) {
      <div class="ui basic button" (click)="deleteQuestion(question)">
        {{ isDeletedQuestion ? "RESTORE" : "DELETE" }}
      </div>
      }
      <!-- END OF TRANSLOCO TODO -->

      @if (!isProductionMode) {
      <div
        (click)="save()"
        [ngClass]="{ loading: isSaving, disabled: !formGroup?.valid }"
        class="ui primary button"
      >
        {{ "settings.save" | transloco }}
      </div>
      }
    </div>
  </div>

  <div id="tabs-menu" class="no-select">
    <div (click)="goToTab(1)" class="tab" [ngClass]="{ active: tab === 1 }">
      {{ "settings.question-uppercase" | transloco }}
    </div>
    <div (click)="goToTab(2)" class="tab" [ngClass]="{ active: tab === 2 }">
      {{ "settings.values-uppercase" | transloco }}
    </div>
    <div (click)="goToTab(3)" class="tab" [ngClass]="{ active: tab === 3 }">
      {{ "settings.dependencies" | transloco }}
    </div>
    @if (questionType?.value === 'table') {
    <div (click)="goToTab(4)" class="tab" [ngClass]="{ active: tab === 4 }">
      {{ "settings.table" | transloco }}
    </div>
    } @if (questionType?.value === 'file') {
    <div (click)="goToTab(5)" class="tab" [ngClass]="{ active: tab === 5 }">
      {{ "settings.file-uppercase" | transloco }}
    </div>
    }
  </div>
</header>

<!-- Tab 1 Question -->
@if (question) {
<div id="body">
  <div [hidden]="tab !== 1" id="question" class="tab">
    <div class="settings-fields">
      <div
        [ngClass]="{ disabled: question?.id && questionType.value === 'table' }"
      >
        <label>{{ "settings.question-type" | transloco }}</label>
        <div class="ui search selection dropdown" #questionTypeDropDown>
          <div class="text"></div>
          <div class="menu"></div>
          <i class="chevron down icon"></i>
        </div>
        <input type="hidden" [formControl]="questionType" />
      </div>
      <div style="display:grid;grid-template-columns:50% 50%;grid-gap:1em;">
        @if (questionType.value !== 'file') {
        <div
          [ngClass]="{
            disabled: question?.id && questionType?.value === 'table'
          }"
          title="{{
            questionType.value === 'table'
              ? 'Table questions cannot also be a tab question'
              : undefined
          }}"
        >
          <label>{{ "settings.tab-question" | transloco }}</label>
          <div class="container">
            <label>
              <input
                [formControl]="isTab"
                type="radio"
                name="isTab"
                [value]="true"
                (change)="onTabValueChanges()"
              />
              <span class="checkmark"></span>
              <span class="lbl-text">{{ "settings.yes" | transloco }}</span>
            </label>
          </div>
          <div class="container">
            <label>
              <input
                [formControl]="isTab"
                type="radio"
                name="isTab"
                [value]="false"
              />
              <span class="checkmark"></span>
              <span class="lbl-text">{{ "settings.no" | transloco }}</span>
            </label>
          </div>
        </div>
        }
        <div>
          <label>{{ "settings.hidden" | transloco }}</label>
          <div class="container">
            <label>
              <input
                [formControl]="hidden"
                type="radio"
                name="hidden"
                [value]="true"
              />
              <span class="checkmark"></span>
              <span class="lbl-text">{{ "settings.yes" | transloco }}</span>
            </label>
          </div>
          <div class="container">
            <label>
              <input
                [formControl]="hidden"
                type="radio"
                name="hidden"
                [value]="false"
              />
              <span class="checkmark"></span>
              <span class="lbl-text">{{ "settings.no" | transloco }}</span>
            </label>
          </div>
        </div>
      </div>
      <div>
        <label>{{ "settings.question" | transloco }}</label>
        <input type="text" [formControl]="questionName" />
      </div>
      <div style="display:grid;grid-template-columns:50% 50%;grid-gap:1em;">
        <div>
          <label>{{ "settings.lock-mode" | transloco }}</label>
          <div class="container">
            <label>
              <input
                [formControl]="lockMode"
                type="radio"
                name="lockMode"
                [value]="'auto'"
              />
              <span class="checkmark"></span>
              <span class="lbl-text">{{
                "settings.auto-mode" | transloco
              }}</span>
            </label>
          </div>
          <div class="container">
            <label>
              <input
                [formControl]="lockMode"
                type="radio"
                name="lockMode"
                [value]="'manual'"
              />
              <span class="checkmark"></span>
              <span class="lbl-text">{{
                "settings.manual-mode" | transloco
              }}</span>
            </label>
          </div>
        </div>
        <div
          [ngClass]="{ disabled: question.lockMode === 'auto' }"
          title="{{ question.lockMode | json }}"
        >
          <label>{{ "settings.lock" | transloco }}</label>
          <div class="container">
            <label>
              <input
                [formControl]="lockType"
                type="radio"
                name="lockType"
                [value]="'hardLock'"
              />
              <span class="checkmark"></span>
              <span class="lbl-text">{{
                "settings.hard-lock" | transloco
              }}</span>
            </label>
          </div>
          <div class="container">
            <label>
              <input
                [formControl]="lockType"
                type="radio"
                name="lockType"
                [value]="'softLock'"
              />
              <span class="checkmark"></span>
              <span class="lbl-text">{{
                "settings.soft-lock" | transloco
              }}</span>
            </label>
          </div>
          <div class="container">
            <label>
              <input
                [formControl]="lockType"
                type="radio"
                name="lockType"
                [value]="'manualInput'"
              />
              <span class="checkmark"></span>
              <span class="lbl-text">{{
                "settings.manual-input" | transloco
              }}</span>
            </label>
          </div>
        </div>
      </div>
      @if ( questionType.value !== 'drop down' && questionType.value !== 'radio'
      && questionType.value !== 'radio' && questionType.value !== 'checkbox' &&
      questionType.value !== 'file' ) {
      <div [ngClass]="{ disabled: questionType.value === 'table' }">
        <label>{{ "settings.default-value" | transloco }}</label>
        @if (questionType.value !== 'number') {
        <input type="text" [formControl]="default" />
        } @if (questionType.value === 'number') {
        <input type="number" [formControl]="default" />
        }
      </div>
      }
      <div style="display:grid;grid-template-columns:50% 50%;grid-gap:1em;">
        <div
          [ngClass]="{
            disabled:
              questionType.value === 'checkbox' ||
              questionType.value === 'table'
          }"
        >
          <label>{{ "settings.mandatory" | transloco }}</label>
          <div class="container">
            <label>
              <input
                [formControl]="mandatory"
                type="radio"
                name="mandatory"
                [value]="true"
              />
              <span class="checkmark"></span>
              <span class="lbl-text">{{ "settings.yes" | transloco }}</span>
            </label>
          </div>
          <div class="container">
            <label>
              <input
                [formControl]="mandatory"
                type="radio"
                name="mandatory"
                [value]="false"
              />
              <span class="checkmark"></span>
              <span class="lbl-text">{{ "settings.no" | transloco }}</span>
            </label>
          </div>
        </div>
        <div>
          <label>{{ "settings.top-level" | transloco }}</label>
          <div class="container">
            <label>
              <input
                [formControl]="topLevel"
                type="radio"
                name="topLevel"
                [value]="true"
              />
              <span class="checkmark"></span>
              <span class="lbl-text">{{ "settings.yes" | transloco }}</span>
            </label>
          </div>
          <div class="container">
            <label>
              <input
                [formControl]="topLevel"
                type="radio"
                name="topLevel"
                [value]="false"
              />
              <span class="checkmark"></span>
              <span class="lbl-text">{{ "settings.no" | transloco }}</span>
            </label>
          </div>
        </div>
      </div>
      @if (questionType.value == 'checkbox') {
      <div>
        <div>
          <label>{{ "settings.default-value" | transloco }}</label>
          <div class="container">
            <label>
              <input
                [formControl]="default"
                type="radio"
                name="default"
                [value]="'true'"
              />
              <span class="checkmark"></span>
              <span class="lbl-text">{{ "settings.checked" | transloco }}</span>
            </label>
          </div>
          <div class="container">
            <label>
              <input
                [formControl]="default"
                type="radio"
                name="default"
                [value]="'false'"
              />
              <span class="checkmark"></span>
              <span class="lbl-text">{{
                "settings.unchecked" | transloco
              }}</span>
            </label>
          </div>
        </div>
      </div>
      }
      <div
        [hidden]="
          questionType.value !== 'drop down' && questionType.value !== 'radio'
        "
        [ngClass]="{ disabled: questionType.value === 'table' }"
      >
        <label>{{ "settings.default-value" | transloco }}</label>
        <div class="ui search selection dropdown" #defaultValueDropdown>
          <input class="search" />
          <div class="text"></div>
          <div class="menu"></div>
          <i class="chevron down icon"></i>
        </div>
      </div>
      @if (questionType.value !== 'file') {
      <div
        [ngClass]="{
          disabled:
            questionType.value !== 'number' || questionType.value === 'table'
        }"
      >
        <label>{{ "settings.min-value" | transloco }}</label>
        <input type="number" [formControl]="min" />
      </div>
      } @if (questionType.value !== 'file') {
      <div
        [ngClass]="{
          disabled:
            questionType.value !== 'number' || questionType.value === 'table'
        }"
      >
        <label>{{ "settings.max-value" | transloco }}</label>
        <input type="number" [formControl]="max" />
      </div>
      } @if (questionType.value !== 'file') {
      <div
        [ngClass]="{
          disabled:
            (questionType.value !== 'text' &&
              questionType.value !== 'number' &&
              questionType.value !== 'textarea') ||
            questionType.value === 'table'
        }"
      >
        <label>{{ "settings.max-characters" | transloco }}</label>
        <input type="number" min="0" [formControl]="maxLength" />
      </div>
      }
      <div
        [ngClass]="{
          disabled:
            questionType.value !== 'number' ||
            questionType.value === 'table' ||
            questionType.value === 'file'
        }"
      >
        <label>{{ "settings.number-options" | transloco }}</label>
        <div class="ui search selection dropdown" #numberOptionsDropDown>
          <div class="text"></div>
          <div class="menu"></div>
          <i class="chevron down icon"></i>
        </div>
      </div>
      <div class="ui equal width grid">
        @if (questionType.value !== 'file') {
        <div
          [ngClass]="{
            disabled:
              questionType.value === 'table' || questionType.value !== 'number'
          }"
        >
          <label>{{ "settings.allow-decimals" | transloco }}</label>
          <div class="container">
            <label>
              <input
                [formControl]="allowDecimals"
                type="radio"
                name="allowDecimals"
                [value]="true"
              />
              <span class="checkmark"></span>
              <span class="lbl-text">{{ "settings.yes" | transloco }}</span>
            </label>
          </div>
          <div class="container">
            <label>
              <input
                [formControl]="allowDecimals"
                type="radio"
                name="allowDecimals"
                [value]="false"
              />
              <span class="checkmark"></span>
              <span class="lbl-text">{{ "settings.no" | transloco }}</span>
            </label>
          </div>
        </div>
        }
        <div
          class="always-editable"
          [ngClass]="{
            disabled: questionType.value === 'table' || isTab.value === true
          }"
        >
          <label>{{ "settings.always-editable" | transloco }}</label>
          <div class="container">
            <label>
              <input
                [formControl]="alwaysEditable"
                type="radio"
                name="alwaysEditable"
                [value]="true"
              />
              <span class="checkmark"></span>
              <span class="lbl-text">{{ "settings.yes" | transloco }}</span>
            </label>
          </div>
          <div class="container">
            <label>
              <input
                [formControl]="alwaysEditable"
                type="radio"
                name="alwaysEditable"
                [value]="false"
              />
              <span class="checkmark"></span>
              <span class="lbl-text">{{ "settings.no" | transloco }}</span>
            </label>
          </div>
        </div>
      </div>
      @if (questionType.value !== 'file') {
      <div>
        <label>{{ "settings.value-format" | transloco }}</label>
        <input
          type="text"
          [formControl]="valueFormat"
          [placeholder]="
            questionType.value === 'image' || questionType.value === 'table'
              ? 'width,height (pixels)'
              : ''
          "
        />
      </div>
      }
      <div>
        <label>{{ "settings.hint" | transloco }}</label>
        <input type="text" [formControl]="hint" />
      </div>
      @if (config.featureFlags.aps) {
      <div [ngClass]="{ disabled: questionType.value === 'table' }">
        <label>{{ "settings.aps-reference" | transloco }}</label>
        <input type="text" [formControl]="APSRef" />
      </div>
      } @if (config.featureFlags.aps) {
      <div [ngClass]="{ disabled: questionType.value === 'table' }">
        <label>{{ "settings.aps-section" | transloco }}</label>
        <input type="text" [formControl]="APSSection" />
      </div>
      } @if (config.featureFlags.aps) {
      <div [ngClass]="{ disabled: questionType.value === 'table' }">
        <label>{{ "settings.aps-subsection" | transloco }}</label>
        <input type="text" [formControl]="APSSubsection" />
      </div>
      } @if (config.featureFlags.aps) {
      <div [ngClass]="{ disabled: questionType.value === 'table' }">
        <label>{{ "settings.aps-question-grouping" | transloco }}</label>
        <input type="text" [formControl]="APSQuestionGrouping" />
      </div>
      } @if (config.featureFlags.aps) {
      <div [ngClass]="{ disabled: questionType.value === 'table' }">
        <label>{{ "settings.aps-dimension" | transloco }}</label>
        <input type="number" min="0" max="2" [formControl]="APSDimension" />
        @if (APSDimension.value > 2) {
        <div class="clear validation-text">
          {{ "settings.value-cannot-be-more-than-2" | transloco }}
        </div>
        } @if (APSDimension.value < 0) {
        <div class="clear validation-text">
          {{ "settings.value-cannot-be-less-than-0" | transloco }}
        </div>
        }
      </div>
      } @if (config.featureFlags.aps) {
      <div [ngClass]="{ disabled: questionType.value === 'table' }">
        <label>{{ "settings.aps-ordering" | transloco }}</label>
        <input type="number" [formControl]="APSOrder" />
      </div>
      } @if (config.featureFlags.aps) {
      <div [ngClass]="{ disabled: questionType.value === 'table' }">
        <label>{{ "settings.aps-calculated-field" | transloco }}</label>
        <div class="container">
          <label>
            <input
              [formControl]="APSCalcField"
              type="radio"
              name="APSCalcField"
              [value]="true"
            />
            <span class="checkmark"></span>
            <span class="lbl-text">{{ "settings.yes" | transloco }}</span>
          </label>
        </div>
        <div class="container">
          <label>
            <input
              [formControl]="APSCalcField"
              type="radio"
              name="APSCalcField"
              [value]="false"
            />
            <span class="checkmark"></span>
            <span class="lbl-text">{{ "settings.no" | transloco }}</span>
          </label>
        </div>
      </div>
      } @if (questionType.value !== 'file') {
      <div [ngClass]="{ disabled: questionType.value === 'table' }">
        <label>{{ "settings.medicare-coordinates" | transloco }}</label>
        <input type="text" [formControl]="medicareCoordinates" />
      </div>
      } @if (questionType.value !== 'file') {
      <div [ngClass]="{ disabled: questionType.value === 'table' }">
        <label>{{ "settings.transmittal-letter-reference" | transloco }}</label>
        <input type="text" [formControl]="transmittalLetterRef" />
      </div>
      }
      <div>
        <label>{{ "settings.tag" | transloco }}</label>
        <input type="text" [formControl]="tag" />
      </div>
      @if (questionType.value !== 'file') {
      <div [ngClass]="{ disabled: questionType.value === 'table' }">
        <label>{{ "settings.tac-reference" | transloco }}</label>
        <input type="text" [formControl]="tacRef" />
      </div>
      } @if (questionType.value !== 'file') {
      <div [ngClass]="{ disabled: questionType.value === 'table' }">
        <label>{{ "settings.lodgement-bot-field" | transloco }}</label>
        <input type="text" [formControl]="lodgementBotField" />
      </div>
      }
      <div
        class="ui equal width grid"
        [ngClass]="{ disabled: questionType.value === 'table' }"
      >
        @if (questionType.value !== 'file') {
        <div [ngClass]="{ disabled: !canUpdateTaxServiceIdentifier }">
          <label>{{ "settings.tax-service-identifier" | transloco }}</label>
          <div class="container">
            <label>
              <input
                [formControl]="taxServiceIdentifier"
                type="radio"
                name="taxServiceIdentifier"
                [value]="true"
              />
              <span class="checkmark"></span>
              <span class="lbl-text">{{ "settings.yes" | transloco }}</span>
            </label>
          </div>
          <div class="container">
            <label>
              <input
                [formControl]="taxServiceIdentifier"
                type="radio"
                name="taxServiceIdentifier"
                [value]="false"
              />
              <span class="checkmark"></span>
              <span class="lbl-text">{{ "settings.no" | transloco }}</span>
            </label>
          </div>
        </div>
        } @if (config.featureFlags.aps) {
        <div [ngClass]="{ disabled: !canUpdateManualAPSEntry }">
          <div>
            <label>{{ "settings.manual-aps-entry" | transloco }}</label>
            <div class="container">
              <label>
                <input
                  [formControl]="isManualAPSEntry"
                  type="radio"
                  name="isManualAPSEntry"
                  [value]="true"
                />
                <span class="checkmark"></span>
                <span class="lbl-text">{{ "settings.yes" | transloco }}</span>
              </label>
            </div>
            <div class="container">
              <label>
                <input
                  [formControl]="isManualAPSEntry"
                  type="radio"
                  name="isManualAPSEntry"
                  [value]="false"
                />
                <span class="checkmark"></span>
                <span class="lbl-text">{{ "settings.no" | transloco }}</span>
              </label>
            </div>
          </div>
        </div>
        }
        <div class="complexity-override">
          <label>{{ "settings.complexity-override" | transloco }}</label>
          <div class="container">
            <label>
              <input
                [formControl]="complexityOverride"
                type="radio"
                name="complexityOverride"
                [value]="true"
              />
              <span class="checkmark"></span>
              <span class="lbl-text">{{ "settings.yes" | transloco }}</span>
            </label>
          </div>
          <div class="container">
            <label>
              <input
                [formControl]="complexityOverride"
                type="radio"
                name="complexityOverride"
                [value]="false"
              />
              <span class="checkmark"></span>
              <span class="lbl-text">{{ "settings.no" | transloco }}</span>
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Tab 2 Values -->
  <div [hidden]="tab !== 2" class="tab" id="values">
    @if ( questionType.value !== 'drop down' && questionType.value !== 'radio' )
    {
    <div>
      <h4>
        {{
          "settings.not-allow-preset-values"
            | transloco: { value: questionType.value }
        }}
      </h4>
      {{ "settings.preset-values" | transloco }}
      <strong>{{ "settings.drop-down" | transloco }}</strong>
      {{ "settings.or" | transloco }}
      <strong>{{ "settings.radio" | transloco }}</strong>
      {{ "settings.questions-lowercase" | transloco }}.
    </div>
    } @if (questionType.value == 'drop down' || questionType.value == 'radio') {
    <div>
      <div class="header-box">
        <h4>{{ "settings.example" | transloco }}</h4>
        <p>
          {{
            "settings.for-the-question-is-this-person-an-australian-citizen-your-values-would-be-yes-and-no-and-each-value-has-a-code-which-is-what-actually-pushes-to-aps-to-go-on-the-return"
              | transloco
          }}
        </p>
        <div>
          <div class="row">{{ "settings.yes" | transloco }}</div>
          <div class="row">{{ "settings.y" | transloco }}</div>
        </div>
        <div>
          <div class="row">{{ "settings.no" | transloco }}</div>
          <div class="row">{{ "settings.n" | transloco }}</div>
        </div>
      </div>
      <div id="values-header">
        <h3>{{ "settings.values" | transloco }}</h3>
        @if (!isProductionMode) {
        <div (click)="addValue()" class="new-value-btn">
          {{ "settings.new-value" | transloco }}
        </div>
        }
      </div>
      <div id="tbl-container">
        <table cellspacing="0" cellpadding="0" width="100%">
          <thead>
            <tr>
              <td style="width: 15em">{{ "settings.display" | transloco }}</td>
              <td style="width: 15em">{{ "settings.value" | transloco }}</td>
              <td style="width: 8em">
                {{ "settings.display-order" | transloco }}
              </td>
              <td style="width: 10em">
                {{ "settings.default-selected" | transloco }}
              </td>
              <td style="width: 8em">{{ "settings.disabled" | transloco }}</td>
              @if (!isProductionMode) {
              <td></td>
              }
            </tr>
          </thead>
          <tbody>
            @for ( valueOption of question.questionDropdowns; track valueOption;
            let index = $index) { @if (valueOption.status === 0) {
            <tr [ngClass]="{ active: valueOption.edit }">
              <td (click)="editValue(valueOption, $event)">
                <input
                  type="text"
                  [(ngModel)]="valueOption.display"
                  (change)="initDefaultValueDropdown(); updatePreview()"
                />
              </td>
              <td (click)="editValue(valueOption, $event)">
                <input
                  type="text"
                  [(ngModel)]="valueOption.value"
                  (change)="initDefaultValueDropdown(); updatePreview()"
                />
              </td>
              <td (click)="editValue(valueOption, $event)">
                <input
                  type="text"
                  [(ngModel)]="valueOption.order"
                  (change)="initDefaultValueDropdown(); updatePreview()"
                />
              </td>
              <td>
                <div class="ui checkbox" [hidden]="valueOption.disabled">
                  <input
                    type="checkbox"
                    [checked]="valueOption.selected"
                    (change)="toggleDefaultValue(valueOption); updatePreview()"
                  />
                </div>
              </td>
              <td>
                <div class="ui checkbox">
                  <input
                    type="checkbox"
                    [(ngModel)]="valueOption.disabled"
                    (change)="initDefaultValueDropdown(); updatePreview()"
                  />
                </div>
              </td>
              @if (!isProductionMode) {
              <td>
                @if (!valueOption.selected) {
                <div
                  (click)="deleteValue(valueOption)"
                  class="delete icon"
                ></div>
                }
              </td>
              }
            </tr>
            } }
          </tbody>
        </table>
      </div>
    </div>
    }
  </div>
  <!-- Tab 3 Dependencies -->
  <div [hidden]="tab !== 3" class="tab" id="dependencies">
    @if ( questionType.value === 'checkbox' || questionType.value === 'table' )
    {
    <div>
      <h4>
        {{
          "settings.you-cannot-set-dependencies-for-question-type-value-questions"
            | transloco: { value: questionType.value }
        }}
      </h4>
    </div>
    }
    <div
      [hidden]="
        questionType.value == 'checkbox' || questionType.value == 'table'
      "
    >
      <div class="header-box">
        <h4>{{ "settings.dependencies" | transloco }}</h4>
        <p>
          {{
            "settings.if-this-question-depends-on-the-answer-of-another-question-use-these-settings-to-define-the-questions-that-it-is-dependant-on-and-the-respective-behaviour-that-depend-on-the-parent-question"
              | transloco
          }}
        </p>
      </div>
      <h5>
        {{
          "settings.question-question-will-become-mandatory-when"
            | transloco: { question: question?.question }
        }}
      </h5>
      <div class="settings-fields">
        <div>
          <label>{{ "settings.another-question" | transloco }}</label>
          <div class="ui search selection dropdown" #depMandQuestionDropDown>
            <input class="search" />
            <div class="text"></div>
            <div class="menu"></div>
            <i class="chevron down icon"></i>
          </div>
        </div>
        <div [hidden]="!question.dependantMandatoryParentId">
          <label>{{ "settings.has" | transloco }}</label>
          <div class="container">
            <label
              (click)="
                question.dependantMandatoryParentValue = null;
                initDepAnsDropdown()
              "
            >
              <input
                [(ngModel)]="dependencyType"
                type="radio"
                name="dependencyType"
                [value]="'any'"
              />
              <span class="checkmark"></span>
              <span class="lbl-text">{{
                "settings.any-answer" | transloco
              }}</span>
            </label>
          </div>
          <div class="container">
            <label>
              <input
                [(ngModel)]="dependencyType"
                type="radio"
                name="dependencyType"
                [value]="'specific'"
              />
              <span class="checkmark"></span>
              <span class="lbl-text">{{
                "settings.a-specific-answer" | transloco
              }}</span>
            </label>
          </div>
        </div>
        @if (dependantMandatoryQuestion) {
        <div
          [ngClass]="{
            disabled:
              dependencyType !== 'specific' ||
              !question.dependantMandatoryParentId
          }"
        >
          <label>{{
            "settings.select-specific-value-answer" | transloco
          }}</label>
          @if ( (dependantMandatoryQuestion.displayFieldType === 'text' ||
          dependantMandatoryQuestion.displayFieldType === 'textarea' ||
          dependantMandatoryQuestion.displayFieldType === 'date picker') &&
          dependantMandatoryQuestion.dataType.toLowerCase() === 'string' ) {
          <input
            type="text"
            [(ngModel)]="question.dependantMandatoryParentValue"
          />
          } @if ( dependantMandatoryQuestion.displayFieldType === 'text' &&
          (dependantMandatoryQuestion.dataType.toLowerCase() === 'integer' ||
          dependantMandatoryQuestion.dataType.toLowerCase() === 'float') ) {
          <input
            type="number"
            max="question.max"
            [(ngModel)]="question.dependantMandatoryParentValue"
          />
          }
          <div
            [hidden]="
              dependantMandatoryQuestion.displayFieldType !== 'drop down' &&
              dependantMandatoryQuestion.displayFieldType !== 'radio'
            "
            class="ui search selection dropdown"
            #depMandAnswerDropdown
          >
            <input class="search" />
            <div class="text"></div>
            <div class="menu"></div>
            <i class="chevron down icon"></i>
          </div>
          <div
            [hidden]="
              dependantMandatoryQuestion.displayFieldType !== 'checkbox'
            "
          >
            <div class="container">
              <label>
                <input
                  [(ngModel)]="question.dependantMandatoryParentValue"
                  type="radio"
                  name="dependantMandatoryParentValue"
                  [value]="'true'"
                />
                <span class="checkmark"></span>
                <span class="lbl-text">{{ "settings.true" | transloco }}</span>
              </label>
            </div>
            <div class="container">
              <label>
                <input
                  [(ngModel)]="question.dependantMandatoryParentValue"
                  type="radio"
                  name="dependantMandatoryParentValue"
                  [value]="'false'"
                />
                <span class="checkmark"></span>
                <span class="lbl-text">{{ "settings.false" | transloco }}</span>
              </label>
            </div>
          </div>
        </div>
        }
      </div>
    </div>
  </div>
  <!-- Tab 4 Table -->
  <div [hidden]="tab !== 4" class="tab" id="table">
    <div [hidden]="questionType.value !== 'table'" id="table-questions">
      <h2>{{ "settings.table-columns" | transloco }}</h2>
      <div class="table-container">
        <table cellspacing="0" cellpadding="0">
          <thead>
            <tr>
              @for (_question of columnQuestions; track _question) {
              <td>
                {{ _question?.question }}
                @if (_question.parentId !== question.id) {
                <div
                  (click)="removeQuestion(_question)"
                  class="delete icon"
                  title="Remove question"
                ></div>
                }
              </td>
              }
            </tr>
          </thead>
          <tbody>
            <tr>
              @for (_question of columnQuestions; track _question) {
              <td>
                {{ _question?.displayFieldType }}
              </td>
              }
            </tr>
          </tbody>
        </table>
      </div>
      @if (!isProductionMode) {
      <span (click)="addExistingQuestion()" class="new-value-btn">{{
        "settings.add-column" | transloco
      }}</span>
      }
      <h2>{{ "settings.chart-configuration" | transloco }}</h2>
      <div class="settings-fields">
        <div class="container">
          <div class="ui checkbox">
            @for (option of displayAsChartOptions; track option) {
            <div>
              <input
                type="checkbox"
                [value]="option.value"
                (change)="updateDisplayAsChart($event)"
                [checked]="isDisplayAsChart.value"
              />
              <label
                ><span class="lbl-text">{{ option.name }}</span></label
              >
              <input />
            </div>
            }
          </div>
        </div>
      </div>
      <div class="container" [ngClass]="{ disabled: !isDisplayAsChart.value }">
        <app-search-dropdown
          label="Chart Type"
          [formCtrl]="chartTypeFormCtrl"
          [listOptions]="chartOptions"
          placeholder="Select..."
        >
        </app-search-dropdown>
      </div>
    </div>
    <div class="warning" [hidden]="!chartRequiredColumnWarning">
      {{ chartRequiredColumnWarningMessage }}
    </div>
    @if (chartConfigRequirements) {
    <div>
      @for (configRequirement of chartConfigRequirements; track
      configRequirement) {
      <div [ngClass]="{ warning: !configRequirement.isValid }">
        <b>{{ configRequirement.questionName }}</b
        >{{ configRequirement.message }}
      </div>
      }
    </div>
    }
  </div>
  <div [hidden]="tab !== 5" class="tab" id="source">
    <div [hidden]="questionType.value !== 'file'" id="source-mapping">
      @if (!question.parentId) {
      <div class="header-box">
        <h4>{{ "settings.source" | transloco }}</h4>
        <p>
          {{
            "settings.if-you-would-like-to-save-values-in-the-file-to-a-source"
              | transloco
          }}
        </p>
      </div>
      } @if (!question.parentId) {
      <h5>
        {{
          "settings.question-will-be-linked-to-source"
            | transloco: { question: question?.question }
        }}
      </h5>
      }
      <div class="settings-fields">
        @if (!question.parentId) {
        <div>
          <label>{{ "settings.source" | transloco }}</label>
          <div class="ui search selection dropdown" #sourceDropdown>
            <input class="search" />
            <div class="text"></div>
            <div class="menu"></div>
            <i class="chevron down icon"></i>
          </div>
        </div>
        } @if (!question.parentId) {
        <div>
          <label>{{ "settings.custom-file-path" | transloco }}</label>
          <input
            type="text"
            (keypress)="omitSpecialCharInCustomFilePath($event)"
            [formControl]="customFilePath"
          />
        </div>
        }
        <div>
          <label
            >{{ "settings.Sharepoint-tags" | transloco }} ({{
              "settings.Sharepoint-tags-example" | transloco
            }})</label
          >
          <input type="text" [formControl]="sharepointTags" />
        </div>
      </div>
    </div>
  </div>
  <!-- Preview -->
  <div
    id="preview"
    [ngClass]="{
      'no-overflow':
        questionType.value === 'drop down' ||
        questionType.value === 'date picker'
    }"
  >
    @if (questionType.value !== 'table') {
    <div>
      <h2>Question Preview</h2>
      @if (prevFormGroup.controls[question.id]) {
      <app-form-field-wrapper
        [formGroup]="prevFormGroup"
        [question]="question"
      ></app-form-field-wrapper>
      }
      <div [hidden]="prevFormGroup.controls[question.id]" class="loading">
        <div class="ui active centered inline loader"></div>
      </div>
    </div>
    } @if (questionType.value === 'table') {
    <div>
      <h4>
        {{
          "settings.preview-is-not-available-for-table-questions" | transloco
        }}
      </h4>
    </div>
    }
  </div>
  <div class="ui huge modal" id="add-question-modal" #addQuestionModal>
    <div class="icon modal-close close"></div>
    <h2>{{ "settings.add-question" | transloco }}</h2>
    <div id="filters">
      <div id="keyword-filter">
        <div class="ui left icon fluid input">
          <i class="search icon"></i>
          <input
            type="text"
            [(ngModel)]="questionSearch"
            placeholder="{{ 'settings.search-questions' | transloco }}"
          />
        </div>
      </div>
    </div>
    <div class="table-container">
      <table width="100%" cellspacing="0">
        <thead>
          <tr>
            <td width="500px">{{ "settings.question" | transloco }}</td>
            <td width="200px" class="no-wrap">
              {{ "settings.type-of-field" | transloco }}
            </td>
            <td width="200px" class="no-wrap">
              {{ "settings.mandatory" | transloco }}
            </td>
            @if (config.featureFlags.aps) {
            <td width="200px" class="no-wrap">
              {{ "settings.aps-reference" | transloco }}
            </td>
            }
            <td></td>
          </tr>
        </thead>
        <tbody>
          @for ( question of questions | keyWord: ['question',
          'APSRef']:questionSearch ; track question) { @if
          (canAddTableQuestion(question)) {
          <tr>
            <td>{{ question?.question }}</td>
            <td>{{ question?.displayFieldType }}</td>
            <td>{{ question?.mandatory ? "Yes" : "No" }}</td>
            @if (config.featureFlags.aps) {
            <td
              textTruncate
              [length]="40"
              [text]="question?.APSRef"
              title="{{ question?.APSRef }}"
            ></td>
            }
            <td (click)="useQuestion(question)" align="right" class="use-btn">
              <strong>{{ "settings.use" | transloco }}</strong>
            </td>
          </tr>
          } }
        </tbody>
      </table>
    </div>
  </div>
</div>
}
